import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import './Carousel.css'
import { Link } from 'react-router-dom'
import DonMario from '../../assets/DonMario.svg'
import Corteva from '../../assets/Corteva.png'
import Bayer from '../../assets/Bayer.png'
import Pigasol from '../../assets/Pigasol.png'
import Stine from '../../assets/Stine.png'

export default function Clientes() {
    const { t } = useTranslation()
    const containerRef = useRef(null)
    const animationRef = useRef(null)
    const speedRef = useRef(window.innerWidth <= 960 ? 0.3 : 0.2) // pixels per frame
    const [logoPositions, setLogoPositions] = useState([])

    // Array de clientes
    const clients = [
        { name: 'Don Mario', logo: DonMario, url: 'https://www.donmario.com/' },
        { name: 'Corteva', logo: Corteva, url: 'https://www.corteva.com.ar/' },
        { name: 'Bayer', logo: Bayer, url: 'https://www.conosur.bayer.com/es/' },
        { name: 'Pigasol', logo: Pigasol, url: 'https://www.pigasol.com/index' },
        { name: 'Stine', logo: Stine, url: 'https://stinesemillas.com.ar/' }
    ]

    // Inicializar posiciones de los logos
    useEffect(() => {
        // Ajustar ancho según el tamaño de pantalla
        const slideWidth = window.innerWidth <= 960 ? 100 : 110 // 90px width + 10px margin en móvil
        // Duplicamos los elementos para hacer el carousel más largo
        const duplicatedClients = [...clients, ...clients]
        const initialPositions = duplicatedClients.map((_, index) => ({
            x: index * slideWidth,
            id: index % clients.length, // Usamos modulo para mantener los IDs originales
            originalIndex: index
        }))
        setLogoPositions(initialPositions)
    }, [])

    useEffect(() => {
        if (logoPositions.length === 0) return

        const container = containerRef.current
        if (!container) return

        const slideWidth = window.innerWidth <= 960 ? 100 : 110

        const animate = () => {
            setLogoPositions(prevPositions => {
                return prevPositions.map(logo => {
                    let newX = logo.x - speedRef.current

                    // Cuando un logo sale completamente por la izquierda,
                    // lo reposicionamos a la derecha del último logo visible
                    if (newX + slideWidth < 0) {
                        // Encontrar la posición más a la derecha de todos los logos
                        const maxX = Math.max(...prevPositions.map(l => l.x))
                        newX = maxX + slideWidth
                    }

                    return {
                        ...logo,
                        x: newX
                    }
                })
            })

            animationRef.current = requestAnimationFrame(animate)
        }

        animationRef.current = requestAnimationFrame(animate)

        // Cleanup
        return () => {
            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current)
            }
        }
    }, [logoPositions.length])

    return (
        <div className="slider-container">
            <div 
                ref={containerRef}
                className="slider"
            >
                <div className="slide-track-infinite">
                    {logoPositions.map((logoPos) => {
                        const client = clients[logoPos.id]
                        return (
                            <div 
                                key={logoPos.originalIndex} 
                                className="slide slide-individual"
                                style={{
                                    transform: `translateX(${logoPos.x}px)`,
                                    position: 'absolute',
                                    left: 0
                                }}
                            >
                                <Link to={client.url} target="_blank" rel="noopener noreferrer">
                                    <img src={client.logo} alt={client.name} />
                                </Link>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}
